var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.35 249.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#df1f20;}.cls-2{fill:#369f37;}.cls-3{fill:#f8b918;}.cls-4{fill:#fff;}.cls-5{fill:#385ca5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.97,249.16c4.46-8.36,8.19-17.1,11.14-26.1-106.2-22.47-214.68-14.92-323.16.45,2.86,8.83,6.45,17.42,10.74,25.65h301.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.99,85.54C306.2,3.99,202.16-24.18,120.62,22.61c-45.32,26-76.19,71.38-83.73,123.09-1.04,7.38-1.61,14.82-1.69,22.27v2.04c.03,9.5.84,18.98,2.44,28.34,67.81-2.89,135.15-12.6,201.01-28.98,37.78-27.74,84.12-40.12,124.29-62.69-2.8-7.27-6.12-14.34-9.94-21.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.88,140.13c-1.25-6.72-2.91-13.37-4.97-19.89-1.39-4.57-3.03-9-4.97-13.37-40.42,22.57-86.71,34.8-124.29,62.64-65.18,17.15-133.04,25.31-201.25,29.03,1.49,8.47,3.62,16.81,6.36,24.96,108.68-15.21,217.16-22.92,323.16-.45,8.91-26.71,10.96-55.22,5.97-82.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.64,219.43c71.89-.38,143.73,3.87,215.08,12.73-46.78-16.11-122.95-26.6-208.81-26.6-81.93,0-154.72,9.5-201.9,24.21,64.97-7.12,130.28-10.58,195.64-10.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.65,93.05c5.97-2.78,5.77-6.61,5.67-8.1-.35-4.18-45.04,7.36-57.47,10.24-.35,0-3.08,1.54-3.43,1.69-24.33,9.36-49.5,16.37-75.17,20.93h0c-21.28,7.06-56.03,41.07-66.02,51.36-1.95,2.07-4.28,3.76-6.86,4.97-11.46,5.54-24.66,6.31-36.69,2.14l-6.51-3.08c-79.05-36.44-120.27-19.59-125.29-17.3-1.94.89-4.97,1.19-5.22,2.49-.25,1.29-.85,1.99-.85,2.83-.11.4.12.81.52.92.07.02.15.03.23.03,2.3,0,4.59-.19,6.86-.55,42.36-7.06,86.21,16.26,109.38,31.47,5.8,3.74,11.41,7.77,16.8,12.08h0c3.23,3.53,1.84,9.35,4.62,12.13,6.64,7.29,15.12,12.65,24.56,15.51,5.72,1.76,11.87,1.48,17.4-.8.55-.25.99-.69,1.24-1.24,23.23-45.69,63-80.8,111.22-98.19h0c14.22-4.82,27.82-11.32,40.52-19.34.35-.25,44.75-19.89,44.75-20.19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgLogo);
export default __webpack_public_path__ + "static/media/SG_logo.b043558f87a42c45fd1cf6d9392f8500.svg";
export { ForwardRef as ReactComponent };